(function ($, Cobalt, undefined) {
    Cobalt.BetterTimeSpanField = {
        initialize: function () {
            $("body").delegate(".time-span-container select, .time-span-container > .better-time-span", "change", function () {
                Cobalt.BetterTimeSpanField.setTimespanValue($(this).parent());
            });

            $("body").delegate(".time-span-container > .better-time-span", "keyup", function () {
                Cobalt.BetterTimeSpanField.setTimespanValue($(this).parent());
            });

            $(".time-span-container").each(function (i, val) {
                var value = $(this).find(".hidden-time-span").val();
                var valElement = $(this).find(".better-time-span");
                var selectElement = $(this).find("select");
                if (value != "") {
                    var daySplit = value.split('.');
                    if (daySplit.length > 1) {
                        valElement.val(daySplit[0]);
                        selectElement.val("days");
                    }
                    else {
                        var parts = value.split(':');
                        if (parts[0] != "00" && parts[0] != "") {
                            if (parts[0].substring(0, 1) == "0") parts[0] = parts[0].substring(1);
                            valElement.val(parts[0]);
                            selectElement.val("hours");
                        }
                        else if (parts[1] != "00" && parts[1] != "") {
                            if (parts[1].substring(0, 1) == "0") parts[1] = parts[1].substring(1);
                            valElement.val(parts[1]);
                            selectElement.val("minutes");
                        }
                    }
                }
            });
        },
        setTimespanValue: function (parent) {
            var type = parent.find("select").val();
            var value = parent.find(".better-time-span").val();
            if (value != "") {
                var hours = "00";
                var minutes = "00";
                var days = "00";
                if (type == "hours") {
                    hours = parseInt(value, 10);
                    if (hours > 23) {
                        days = parseInt((hours / 23), 10);
                        hours = parseInt((hours % 24), 10);
                    }
                }
                else if (type == "days") {
                    days = value;
                }
                else if (type == "minutes") {
                    minutes = parseInt(value, 10);
                    if (minutes > 59) {
                        hours = parseInt((minutes / 59), 10);
                        minutes = parseInt((minutes % 60), 10);
                        if (hours > 23) {
                            days = parseInt((hours / 23), 10);
                            hours = parseInt((hours % 24), 10);
                        }
                    }
                }
                var packedValue = days + ":" + hours.toString() + ":" + minutes.toString() + ":0";
                parent.find(".hidden-time-span").val(packedValue);
            }
        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.BetterTimeSpanField.js